<template>
  <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    fixed
    :dark="$vuetify.dark"
    app
    v-model="drawer"
    width="260"
    >
    <v-toolbar color="primary darken-1" flat dark>
      <v-toolbar-title class="pt-2">
          GRUPO NALVARTE
      </v-toolbar-title>        
    </v-toolbar>
    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-list dense expand class="pt-0">
       <template>
          <v-list-group no-action="no-action" :value="menuItemPrincipal">
            <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title class="font-weight-bold"> INTERBANK AGENTE</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
          <template v-for="(item, i) in menus">
          <!--<div v-for="roles in item.roles">-->
          <div v-if="item.roles && item.roles.includes(role) && item.name != 'Usuarios' && item.name != 'logOut' ">
            <!--group with subitems-->
            <v-list-group v-if="item.items" :key="item.name" :group="item.group"  no-action="no-action">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>

                  <v-list-tile-title class="font-weight-bold"> {{ item.title }} </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <!--<div v-for="roles in subItem.roles">-->
                  <v-list-tile v-if="subItem.roles && subItem.roles.includes(role)" :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="subItem.action">
                      <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
               <!-- </div>-->  
              </template>
            </v-list-group>
            <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-tile v-else :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-tile-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </div>
          <!--</div>-->
        </template>
          </v-list-group>
        </template>



        <template>
          <v-list-group no-action="no-action" :value="menuItemPrincipal">
            <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title class="font-weight-bold"> GLOBAL NET</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
          <template v-for="(item, i) in menusGN">
          <!--<div v-for="roles in item.roles">-->
          <div v-if="item.roles && item.roles.includes(role) && item.name != 'Usuarios' && item.name != 'logOut' ">
            <!--group with subitems-->
            <v-list-group v-if="item.items" :key="item.name" :group="item.group"  no-action="no-action">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>

                  <v-list-tile-title class="font-weight-bold"> {{ item.title }} </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <!--<div v-for="roles in subItem.roles">-->
                  <v-list-tile v-if="subItem.roles && subItem.roles.includes(role)" :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="subItem.action">
                      <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
               <!-- </div>-->  
              </template>
            </v-list-group>
            <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-tile v-else :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-tile-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </div>
          <!--</div>-->
        </template>
          </v-list-group>
        </template>




        <template v-for="(item, i) in menus">
          <!--<div v-for="roles in item.roles">-->
          <div v-if="item.roles && item.roles.includes(role) && (item.name === 'Usuarios' || item.name === 'logOut') " @click="menuItemPrincipal = false">
            <!--group with subitems-->
            <v-list-group v-if="item.items" :key="item.name" :group="item.group"  no-action="no-action" >
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>

                  <v-list-tile-title class="font-weight-bold"> {{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <!--<div v-for="roles in subItem.roles">-->
                  <v-list-tile v-if="subItem.roles && subItem.roles.includes(role)" :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="subItem.action">
                      <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                <!--</div>-->  
              </template>
            </v-list-group>
            <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-tile v-else :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-tile-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </div>
          <!--</div>-->
        </template>
        
      </v-list>        
    </vue-perfect-scrollbar>        
  </v-navigation-drawer>
</template>
<script>
import menu from '@/api/menu';
import menuGN from '@/api/menuGN';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  name: 'app-drawer',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    mini: false,
    role: '',
    drawer: true,
    menus: menu,
    menusGN: menuGN,
    scrollSettings: {
      maxScrollbarLength: 160
    },
    menuItemPrincipal:true
  }),
  computed: {
    computeGroupActive () {
      return true;
    },
    computeLogo () {
      return '/static/m.png';
    },

    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    }    
  },
  created () {
    window.getApp.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer);
    });
    this.setRole()

  },
  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return { name: `${item.group}/${(subItem.name)}` };
    },
    setRole(){
      if( window.localStorage.role !== undefined ){
        var role = localStorage.getItem('role')
          role = role.replace(/[ '"]+/g, '')
        this.role = Number(role);
      }
    },

    
  }
};
</script>


<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

#appDrawer
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto

</style>
